<template>
	<div class="flex wrap xs-12">
		<!-- Stepper/Left -->
		<div class="xs-last md-first bg5 br1 bc7" :class="decideStepperWidth">
			<case-steps :tree="steps" @node:select="selectStep"></case-steps>
		</div>

		<!-- Center -->
		<div class="flex xs-column xs sm-pl4 sm-pr4 sm-pb4 md-pl6 md-pb6 md-pr6">
			<div class="flex xs-center md-between mt8">
				<div class="xs-0 md-block">
					<j-button
						:type="showStepper ? 'primary' : 'bordered'"
						size="xsmall"
						class="mr2"
						@click="showStepper = !showStepper"
						>{{
							showStepper ? $t("hide_stepper") : $t("show_stepper")
						}}</j-button
					>
				</div>

				<div class="flex">
					<j-button
						:type="showEnglish ? 'primary' : 'bordered'"
						size="xsmall"
						class="mr2"
						@click="showEnglish = !showEnglish"
						>{{
							showEnglish ? $t("hide_english") : $t("show_english")
						}}</j-button
					>
					<j-button
						:type="showSimplified ? 'primary' : 'bordered'"
						size="xsmall"
						@click="showSimplified = !showSimplified"
						>{{
							showSimplified ? $t("hide_simplified") : $t("show_simplified")
						}}</j-button
					>
				</div>
			</div>

			<div class="flex xs-column md-row">
				<component
					class="xs pr1 pl1"
					v-for="(locale, i) in localesToDisplay"
					:key="i"
					:is="componentToDisplay(locale.id)"
					v-show="isLocaleDisplayed(locale.id)"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import CaseSteps from "../../CaseSteps/"
import JButton from "@/components/JButton/"
import { i18n } from "@/locales/setup.js"

// schemas
import ProposedLifeInsured from "./Schemas/ProposedLifeInsured"
import ExistingAndPendingInsurance from "./Schemas/ExistingAndPendingInsurance"
import LifestyleAndOccupationInformation from "./Schemas/LifestyleAndOccupationInformation"
import TravelDetails from "./Schemas/TravelDetails"
import SmokingStatus from "./Schemas/SmokingStatus"
import FamilyHistory from "./Schemas/FamilyHistory"
import FamilyHistoryContinued from "./Schemas/FamilyHistoryContinued"
import MedicalInformation from "./Schemas/MedicalInformation"
import HealthHistory from "./Schemas/HealthHistory"
import PoliticallyExposedPersonInformation from "./Schemas/PoliticallyExposedPersonInformation"
import SourceOfFunds from "./Schemas/SourceOfFunds"
import ThirdPartyInformation from "./Schemas/ThirdPartyInformation"
import PersonalInformation from "./Schemas/PersonalInformation"
import PersonalIncomeStatement from "./Schemas/PersonalIncomeStatement"
import PersonalBalanceIncomeAssets from "./Schemas/PersonalBalanceIncomeAssets"
import PersonalBalanceIncomeLiabilities from "./Schemas/PersonalBalanceIncomeLiabilities"
import BankReferences from "./Schemas/BankReferences"
import BusinessFinancialStatement from "./Schemas/BusinessFinancialStatement"

import ProposedLifeInsuredCN from "./Schemas/ProposedLifeInsuredCN"
import ExistingAndPendingInsuranceCN from "./Schemas/ExistingAndPendingInsuranceCN"
import LifestyleAndOccupationInformationCN from "./Schemas/LifestyleAndOccupationInformationCN"
import TravelDetailsCN from "./Schemas/TravelDetailsCN"
import SmokingStatusCN from "./Schemas/SmokingStatusCN"
import FamilyHistoryCN from "./Schemas/FamilyHistoryCN"
import FamilyHistoryContinuedCN from "./Schemas/FamilyHistoryContinuedCN"
import MedicalInformationCN from "./Schemas/MedicalInformationCN"
import HealthHistoryCN from "./Schemas/HealthHistoryCN"
import PoliticallyExposedPersonInformationCN from "./Schemas/PoliticallyExposedPersonInformationCN"
import SourceOfFundsCN from "./Schemas/SourceOfFundsCN"
import ThirdPartyInformationCN from "./Schemas/ThirdPartyInformationCN"
import PersonalInformationCN from "./Schemas/PersonalInformationCN"
import PersonalIncomeStatementCN from "./Schemas/PersonalIncomeStatementCN"
import PersonalBalanceIncomeAssetsCN from "./Schemas/PersonalBalanceIncomeAssetsCN"
import PersonalBalanceIncomeLiabilitiesCN from "./Schemas/PersonalBalanceIncomeLiabilitiesCN"
import BankReferencesCN from "./Schemas/BankReferencesCN"
import BusinessFinancialStatementCN from "./Schemas/BusinessFinancialStatementCN"

import HealthQuestionnaire1 from "./Schemas/HealthQuestionnaire1"
import HealthQuestionnaire2 from "./Schemas/HealthQuestionnaire2"

import HealthQuestionnaire1CN from "./Schemas/HealthQuestionnaire1CN"
import HealthQuestionnaire2CN from "./Schemas/HealthQuestionnaire2CN"

import AviationQuestionnaire from "./Schemas/AviationQuestionnaire"
import AviationQuestionnaireCN from "./Schemas/AviationQuestionnaireCN"

import SkinAndScubaDivingQuestionnaire from "./Schemas/SkinAndScubaDivingQuestionnaire"
import RockAndMountainClimbingQuestionnaire from "./Schemas/RockAndMountainClimbingQuestionnaire"
import HangGlidingQuestionnaire from "./Schemas/HangGlidingQuestionnaire"
import SkyDivingQuestionnaire from "./Schemas/SkyDivingQuestionnaire"
import RacingQuestionnaire from "./Schemas/RacingQuestionnaire"

import SkinAndScubaDivingQuestionnaireCN from "./Schemas/SkinAndScubaDivingQuestionnaireCN"
import RockAndMountainClimbingQuestionnaireCN from "./Schemas/RockAndMountainClimbingQuestionnaireCN"
import HangGlidingQuestionnaireCN from "./Schemas/HangGlidingQuestionnaireCN"
import SkyDivingQuestionnaireCN from "./Schemas/SkyDivingQuestionnaireCN"
import RacingQuestionnaireCN from "./Schemas/RacingQuestionnaireCN"

import SupplementalInformation from "./Schemas/SupplementalInformation"
import SupplementalInformationCN from "./Schemas/SupplementalInformationCN"

export default {
	components: {
		CaseSteps,
		JButton,

		ProposedLifeInsured,
		ExistingAndPendingInsurance,
		LifestyleAndOccupationInformation,
		TravelDetails,
		SmokingStatus,
		FamilyHistory,
		FamilyHistoryContinued,
		MedicalInformation,
		HealthHistory,
		PoliticallyExposedPersonInformation,
		SourceOfFunds,
		ThirdPartyInformation,
		PersonalInformation,
		PersonalIncomeStatement,
		PersonalBalanceIncomeAssets,
		PersonalBalanceIncomeLiabilities,
		BankReferences,
		BusinessFinancialStatement,

		ProposedLifeInsuredCN,
		ExistingAndPendingInsuranceCN,
		LifestyleAndOccupationInformationCN,
		TravelDetailsCN,
		SmokingStatusCN,
		FamilyHistoryCN,
		FamilyHistoryContinuedCN,
		MedicalInformationCN,
		HealthHistoryCN,
		PoliticallyExposedPersonInformationCN,
		SourceOfFundsCN,
		ThirdPartyInformationCN,
		PersonalInformationCN,
		PersonalIncomeStatementCN,
		PersonalBalanceIncomeAssetsCN,
		PersonalBalanceIncomeLiabilitiesCN,
		BankReferencesCN,
		BusinessFinancialStatementCN,

		HealthQuestionnaire1,
		HealthQuestionnaire2,

		HealthQuestionnaire1CN,
		HealthQuestionnaire2CN,

		AviationQuestionnaire,
		AviationQuestionnaireCN,

		SkinAndScubaDivingQuestionnaire,
		RockAndMountainClimbingQuestionnaire,
		HangGlidingQuestionnaire,
		SkyDivingQuestionnaire,
		RacingQuestionnaire,

		SkinAndScubaDivingQuestionnaireCN,
		RockAndMountainClimbingQuestionnaireCN,
		HangGlidingQuestionnaireCN,
		SkyDivingQuestionnaireCN,
		RacingQuestionnaireCN,
		SupplementalInformation,
		SupplementalInformationCN
	},

	data() {
		return {
			showEnglish: true,
			showSimplified: false,
			showTraditional: false,
			showStepper: true,
			step: "",
			steps: [
				{
					id: "ProposedLifeInsured",
					title: this.t("proposed_life_insured"),
					component: {
						EN: "ProposedLifeInsured",
						CN: "ProposedLifeInsuredCN",
						HK: ""
					}
				},
				{
					id: "ExistingAndPendingInsurance",
					title: this.t("existing_and_pending_insurance"),
					component: {
						EN: "ExistingAndPendingInsurance",
						CN: "ExistingAndPendingInsuranceCN",
						HK: ""
					}
				},
				{
					id: "LifestyleAndOccupationInformation",
					title: this.t("lifestyle_and_occupation_information"),
					component: {
						EN: "LifestyleAndOccupationInformation",
						CN: "LifestyleAndOccupationInformationCN",
						HK: ""
					}
				},
				{
					id: "TravelDetails",
					title: this.t("travel_details"),
					component: {
						EN: "TravelDetails",
						CN: "TravelDetailsCN",
						HK: ""
					}
				},
				{
					id: "SmokingStatus",
					title: this.t("smoking_status"),
					component: {
						EN: "SmokingStatus",
						CN: "SmokingStatusCN",
						HK: ""
					}
				},
				{
					id: "FamilyHistory",
					title: this.t("family_history"),
					component: {
						EN: "FamilyHistory",
						CN: "FamilyHistoryCN",
						HK: ""
					}
				},
				{
					id: "FamilyHistoryContinued",
					title: this.t("family_history_continued"),
					component: {
						EN: "FamilyHistoryContinued",
						CN: "FamilyHistoryContinuedCN",
						HK: ""
					}
				},
				{
					id: "MedicalInformation",
					title: this.t("medical_information"),
					component: {
						EN: "MedicalInformation",
						CN: "MedicalInformationCN",
						HK: ""
					}
				},
				{
					id: "HealthHistory",
					title: this.t("health_history"),
					component: {
						EN: "HealthHistory",
						CN: "HealthHistoryCN",
						HK: ""
					}
				},
				{
					id: "PoliticallyExposedPersonInformation",
					title: this.t("politically_exposed_person_information"),
					component: {
						EN: "PoliticallyExposedPersonInformation",
						CN: "PoliticallyExposedPersonInformationCN",
						HK: ""
					}
				},
				{
					id: "SourceOfFunds",
					title: this.t("source_of_funds"),
					component: {
						EN: "SourceOfFunds",
						CN: "SourceOfFundsCN",
						HK: ""
					}
				},
				{
					id: "ThirdPartyInformation",
					title: this.t("third_party_information"),
					component: {
						EN: "ThirdPartyInformation",
						CN: "ThirdPartyInformationCN",
						HK: ""
					}
				},
				{
					id: "PersonalInformation",
					title: this.t("personal_information"),
					component: {
						EN: "PersonalInformation",
						CN: "PersonalInformationCN",
						HK: ""
					}
				},
				{
					id: "PersonalIncomeStatement",
					title: this.t("personal_income_statement"),
					component: {
						EN: "PersonalIncomeStatement",
						CN: "PersonalIncomeStatementCN",
						HK: ""
					}
				},
				{
					id: "PersonalBalanceIncomeAssets",
					title: this.t("personal_balance_income_assets"),
					component: {
						EN: "PersonalBalanceIncomeAssets",
						CN: "PersonalBalanceIncomeAssetsCN",
						HK: ""
					}
				},
				{
					id: "PersonalBalanceIncomeLiabilities",
					title: this.t("personal_balance_income_liabilities"),
					component: {
						EN: "PersonalBalanceIncomeLiabilities",
						CN: "PersonalBalanceIncomeLiabilitiesCN",
						HK: ""
					}
				},
				{
					id: "BankReferences",
					title: this.t("bank_references"),
					component: {
						EN: "BankReferences",
						CN: "BankReferencesCN",
						HK: ""
					}
				},
				{
					id: "BusinessFinancialStatement",
					title: this.t("businesss_financial_statement"),
					component: {
						EN: "BusinessFinancialStatement",
						CN: "BusinessFinancialStatementCN",
						HK: ""
					}
				},
				{
					id: "HealthQuestionnaire1",
					title: this.t("health_questionnaire_1"),
					component: {
						EN: "HealthQuestionnaire1",
						CN: "HealthQuestionnaire1CN",
						HK: ""
					}
				},
				{
					id: "HealthQuestionnaire2",
					title: this.t("health_questionnaire_2"),
					component: {
						EN: "HealthQuestionnaire2",
						CN: "HealthQuestionnaire2CN",
						HK: ""
					}
				},
				{
					id: "AviationQuestionnaire",
					title: this.t("aviation_questionnaire"),
					component: {
						EN: "AviationQuestionnaire",
						CN: "AviationQuestionnaireCN",
						HK: ""
					}
				},
				{
					id: "SkinAndScubaDivingQuestionnaire",
					title: this.t("skin_and_scuba_diving_questionnaire"),
					component: {
						EN: "SkinAndScubaDivingQuestionnaire",
						CN: "SkinAndScubaDivingQuestionnaireCN",
						HK: ""
					}
				},
				{
					id: "RockAndMountainClimbingQuestionnaire",
					title: this.t("rock_and_mountain_climbing_questionnaire"),
					component: {
						EN: "RockAndMountainClimbingQuestionnaire",
						CN: "RockAndMountainClimbingQuestionnaireCN",
						HK: ""
					}
				},
				{
					id: "HangGlidingQuestionnaire",
					title: this.t("hang_gliding_questionnaire"),
					component: {
						EN: "HangGlidingQuestionnaire",
						CN: "HangGlidingQuestionnaireCN",
						HK: ""
					}
				},
				{
					id: "SkyDivingQuestionnaire",
					title: this.t("sky_diving_questionnaire"),
					component: {
						EN: "SkyDivingQuestionnaire",
						CN: "SkyDivingQuestionnaireCN",
						HK: ""
					}
				},
				{
					id: "RacingQuestionnaire",
					title: this.t("racing_questionnaire"),
					component: {
						EN: "RacingQuestionnaire",
						CN: "RacingQuestionnaireCN",
						HK: ""
					}
				},
				{
					id: "SupplementalInformation",
					title: this.t("supplemental_information"),
					component: {
						EN: "SupplementalInformation",
						CN: "SupplementalInformationCN",
						HK: ""
					}
				}
			]
		}
	},

	methods: {
		selectStep(stepToSelect) {
			// Select tab
			this.step = stepToSelect.id

			// Change selected tab
			this.steps = this.steps.map(step => ({
				...step,
				isSelected: stepToSelect.id === step.id ? true : false
			}))
		},

		componentToDisplay(locale) {
			return this.steps?.find(item => item.id === this.step)?.component?.[
				locale
			]
		},

		isLocaleDisplayed(locale) {
			return this.localesToDisplay?.find(item => item.id === locale)
				?.isDisplayed
		},

		t(key) {
			const locale = {
				"en-US": {
					proposed_life_insured: "Proposed Life Insured",
					existing_and_pending_insurance: "Existing and Pending Insurance",
					lifestyle_and_occupation_information:
						"Lifestyle and Occupation Information",
					travel_details: "Travel Details",
					smoking_status: "Smoking Status",
					drug_habits: "Drug Habits",
					alcohol_consumption: "Alcohol Consumption",
					family_history: "Family History",
					family_history_continued: "Family History Continued",
					medical_information: "Medical Information",
					health_history: "Health History",
					politically_exposed_person_information:
						"Politically Exposed Person Information",
					source_of_funds: "Source Of Funds",
					third_party_information: "Third Party Infomation",
					personal_information: "Personal Information",
					personal_income_statement: "Personal Income Statement",
					personal_balance_income_assets: "Personal Balance Income (Assets)",
					personal_balance_income_liabilities:
						"Personal Balance Income (Liabilities)",
					bank_references: "Bank References",
					aviation_questionnaire_continued: "Aviation Questionnaire Continued",
					businesss_financial_statement: "Business Financial Statement",
					health_questionnaire_1: "Health Questionnaire I",
					health_questionnaire_2: "Health Questionnaire II",
					aviation_questionnaire: "Aviation Questionnaire",
					skin_and_scuba_diving_questionnaire:
						"Skin and Scuba Diving Questionnaire",
					rock_and_mountain_climbing_questionnaire:
						"Rock and Mountain Climbing Questionnaire",
					hang_gliding_questionnaire: "Hang Gliding Questionnaire",
					sky_diving_questionnaire: "Sky Diving Questionnaire",
					racing_questionnaire:
						"Organized Automobile, Motorcycle and Power Boat Racing",
					supplemental_information: "Supplemental Information"
				},
				"zh-CN": {
					client_particulars: "客户资料",
					existing_and_pending_insurance: "现有和待定保险",
					lifestyle_and_occupation: "生活方式和职业",
					travel_details: "旅行详细信息",
					smoking_status: "吸烟状态",
					family_history: "家族史",
					doctor_information: "医生信息",
					health_history: "健康史",
					health_details: "健康详细信息",
					politically_exposed_person: "政治暴露者",
					source_of_funds: "资金来源",
					third_party: "第三方",
					employment_details: "就业明细",
					personal_income_statement: "个人损益表",
					personal_balance_statement: "个人余额声明",
					client_property: "客户财产",
					financial_references: "财务参考",
					aviation_questionnaire_continued: "航空问卷续",
					business_financial_statement: "企业财务报表",
					consent_and_authorization: "同意和授权",
					proposed_life_insured: "受保人",
					lifestyle_and_occupation_information: "生活方式和职业信息",
					drug_habits: "吸毒习惯",
					alcohol_consumption: "饮酒习惯",
					medical_information: "医疗信息",
					politically_exposed_person_information: "政治人物信息",
					personal_information: "个人信息",
					avocation_questionnaire: "危险运动与嗜好问卷",
					health_questionnaire_1: "Health Questionnaire I",
					health_questionnaire_2: "Health Questionnaire II",
					aviation_questionnaire: "航空问卷",
					skin_and_scuba_diving_questionnaire: "皮肤和水肺潜水问卷",
					rock_and_mountain_climbing_questionnaire: "攀岩问卷",
					hang_gliding_questionnaire: "悬挂式滑行问卷",
					sky_diving_questionnaire: "跳伞问卷",
					racing_questionnaire: "有组织的汽车,摩托车和动力赛艇",
					supplemental_information: "Supplemental Information"
				}
			}
			return locale[i18n.locale][key]
		}
	},

	computed: {
		currentStepProps() {
			return this.steps?.find(item => item.id === this.step)?.props
		},

		decideStepperWidth() {
			return this.showStepper ? "xs-12 md-2" : "xs-0"
		},

		decideCaseDetailWidth() {
			return this.showCaseDetails ? "xs-12 md-3 " : "xs-0"
		},

		localesToDisplay() {
			return [
				{
					id: "EN",
					isDisplayed: this.showEnglish
				},
				{
					id: "CN",
					isDisplayed: this.showSimplified
				}
			]
		}
	},

	created() {
		this.selectStep({ id: "ProposedLifeInsured" })
	}
}
</script>
